import React from "react";

const TitleField = ({ title, description, index, questionIdx }) => {
  return (
    <div className="mb-4">
      <div className="text-[#25282B] font-semibold text-[0.875rem]">
        {title}
      </div>
      <div className="pt-2" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

export default TitleField;
